import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { setAuthStore } from '@unsw/api/client'
import { createQueryClient } from '@unsw/api/query-client'
import { setAppVariant } from '@unsw/config'
import { useAuthStore } from '@unsw/store/auth'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Import routes
import { routeTree } from './routeTree.gen'

// Import styles
import '@unsw/ui/globals.css'
import './index.css'

// Set app variant for feature flags
setAppVariant('unsw-frontend')

// Connect auth store to API client (for automatic token injection + refresh)
setAuthStore(useAuthStore.getState())

// Create query client
const queryClient = createQueryClient()

// Create router
const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
})

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Render app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement)
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  )
}
